import React, { useState } from 'react';
import { withRouter, Link, useParams } from 'react-router-dom';
import { compose } from 'recompose';

import { API } from 'aws-amplify'

import * as ROUTES from '../../constants/routes';
import { Alert, Button, Container, Form, FormGroup, Row, Col, Spinner } from "react-bootstrap";

import { Formik } from 'formik';
import * as Yup from 'yup';

import { Helmet } from 'react-helmet';

const validationSchema = Yup.object().shape({
  username: Yup.string()
  .min(2, "Username must have at least 2 characters.")
  .max(64, "Username can't be longer than 64 characters.")
  .required("Username is required.")
  .matches(
    /^[a-zA-Z0-9]+([_ -]?[a-zA-Z0-9])*$/,
    "Username may contain only letters and numbers, optionally separated by underscores (_) or dashes (-)."
  ),
  email: Yup.string()
  .email("Must be a valid email address.")
  .required("Email is required."),
  emailConfirm: Yup.string()
    .required("Please confirm your email address.")
    .label('Confirm email')
    .test('emails-match', 'Emails must match.', function(value) {
      return this.parent.email === value;
  }),
  licenseKey: Yup.string()
  .required("License Key is required.")
  .label('License Key')
  .matches(
    /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$/,
    "Must conform to the specified license key format."
  ),
  acceptTerms: Yup.bool()
  .oneOf([true], 'Please read and accept the ToS.'),
});


const SignUpKitPage = () => (
    <Container style={{padding:0}}>
        <Helmet>
          <title>Sign Up (Activation Kit) | PWT</title>
          <meta name="description" content="Sign up using an Activation Card from a PWT Activation Kit."/>
        </Helmet>   
        <SignUpKitBase></SignUpKitBase>
    </Container>            
);

function QueryURL() {
  let { key } = useParams();
  if (key == null) {
    key = ''
  }
  return {key}
}

function SignUpKitBase(props) {

  return(
    <div style={{backgroundColor:"whitesmoke", borderRadius:"25px", marginTop:15, marginBottom:15, padding:15}}>
      <h1>Sign Up</h1>
      <SignUpKitForm></SignUpKitForm>
      <div style={{paddingTop:10}}>
        <Link to={ROUTES.SIGN_IN}>Already have an account? Sign in.</Link>
        <br/>
        <a href='https://warningtemperature.health/shop' target='_blank' rel="noopener noreferrer">Need an Activation Kit? Purchase one today.</a>
      </div>
    </div>  
  );
}

function SignUpKitModule(props) {
    let query = QueryURL();

    const [showError, setShowError] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");

    const [formState, setFormState] = useState("signup");

    if (formState === "signup") {
      return(
        <div>    
          <h2>Activation Card</h2>
          <p>Sign up using an Activation Card from a PWT Activation Kit.</p>   
          <Formik
            initialValues={{username:"", email: "", emailConfirm: "", licenseKey:query.key, acceptTerms:false}}
            validationSchema={validationSchema}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
              setSubmitting(true);
              setShowError(false);
              const requestData = {
                body: {
                  username: values.username,
                  email: values.email,
                  license: values.licenseKey,
                }
              }
              try {
                await API.post('temperaturetrackapi', '/register', requestData)
                setFormState("success");
              } catch (error) {
                console.log(error);
                console.log(error.response.data.message)
                setErrorMessage(error.response.data.details.message);
                setShowError(true);
              }
            }}
          >
          {( {values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting }) => (
            <Form onSubmit={handleSubmit} className="mx-auto">
              <Row>
                  <Col>
                    <Form.Group controlId="formUsername">
                    <Form.Label>Username:</Form.Label>
                      <Form.Control
                        type="text"
                        name="username"
                        autoComplete={"username"}
                        placeholder="example-user-42"
                        disabled={isSubmitting}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.username}
                        isInvalid={errors.username && touched.username}
                        isValid={!errors.username && touched.username}
                      />
                      <Form.Control.Feedback type="invalid" style={{
                              color: '#dc3545',
                              fontSize: '.8em',
                      }}>
                        {errors.username}
                      </Form.Control.Feedback>
                      <Form.Control.Feedback type="valid">Be sure to write this down. Do not use personally identifiable information.</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group controlId="formEmail">
                        <Form.Label>Email Address:</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="john@example.com"
                          disabled={isSubmitting}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          isInvalid={errors.email && touched.email}
                          isValid={!errors.email && touched.email}
                        />
                        <Form.Control.Feedback type="invalid" style={{
                                color: '#dc3545',
                                fontSize: '.8em',
                              }}>
                          {errors.email}
                        </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="formEmailConfirm">
                        <Form.Label>Confirm Email Address:</Form.Label>
                        <Form.Control
                          type="emailConfirm"
                          name="emailConfirm"
                          placeholder="john@example.com"
                          disabled={isSubmitting}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.emailConfirm}
                          isInvalid={errors.emailConfirm && touched.emailConfirm}
                          isValid={!errors.emailConfirm && touched.emailConfirm}
                        />
                        <Form.Control.Feedback type="invalid" style={{
                                color: '#dc3545',
                                fontSize: '.8em',
                              }}>
                          {errors.emailConfirm}
                        </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <hr/>
                <Row>
                  <Col>
                    <Form.Group controlId="formLicenseKey">
                        <Form.Label>License Key:</Form.Label>
                        <Form.Control
                          type="text"
                          name="licenseKey"
                          placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                          disabled={isSubmitting}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.licenseKey}
                          isInvalid={errors.licenseKey && touched.licenseKey}
                          isValid={!errors.licenseKey && touched.licenseKey}
                          style={{textTransform:'uppercase'}}
                        />
                        <Form.Control.Feedback type="invalid" style={{
                                color: '#dc3545',
                                fontSize: '.8em',
                              }}>
                          {errors.licenseKey}
                        </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              <FormGroup controlId="agreeToTerms">
                <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
                    <Form.Check 
                      label={`I agree with the`} 
                      name="acceptTerms" 
                      value={values.acceptTerms}
                      disabled={isSubmitting} 
                      onChange={handleChange}>
                    </Form.Check>
                    <a href='/terms-of-service' target='_blank' rel="noopener noreferrer">Terms of Service</a> 
                    {errors.acceptTerms && touched.acceptTerms ? (
                      <div style={{
                        color: '#dc3545',
                        // padding: '.5em .2em',
                        // height: '1em',
                        fontSize: '.8em',
                      }}>{errors.acceptTerms}</div>
                    ): <div style={{
                      color: '#dc3545',
                      // padding: '.5em .2em',
                      // height: '1em',
                      fontSize: '.8em',
                    }}><br/></div>}   
                  </div>
              </FormGroup>
              <Alert show={showError} variant="danger">
              <Alert.Heading>Error Signing Up</Alert.Heading>
                <p>{errorMessage}</p>
                <hr />
                <div className="d-flex justify-content-end">
                  <Button onClick={() => setShowError(false)} variant="outline-danger">
                    Dismiss
                  </Button>
                </div>
              </Alert>
              <Button className='pwt-button' block size="lg" type="submit" disabled={isSubmitting}>
                Sign Up
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  hidden={!isSubmitting}
                  style={{marginLeft: 5}}
                />
                <span className="sr-only">Loading...</span>
              </Button>
            </Form>
              )}
          </Formik>
        </div>         
    );
    } else if (formState === "success") {
      return (
        <div>      
          <h2>Welcome to PWT!</h2>
          <h3>Check your email for your temporary password in order to sign in for the first time.</h3>
        </div> 
      );
  } else {
    return null;
  }
    
    
}


const SignUpKitForm = compose(
  withRouter,
)(SignUpKitModule);

export { SignUpKitForm };

export default SignUpKitPage;